import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Button, Modal, ModalFooter } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
// import fileDownload from 'js-file-download';
//components
import PageTitle from "../../components/common/pageTitle";
import { Tiles, Content, ModalForms } from "../../components/ilifestylepoint";
import { AlertMessage, FormInputControl } from "../../components/common";
import Spinner from "../../shared/Spinner";
import { useSelector } from "react-redux";

//style
import style from "../../components/ilifestylepoint/ilifepoint.module.scss";
// import IlifeModal from "../../components/ilifestylepoint/IlifeModal"
import PaypalPayment from "../../components/Payments/PaypalPayment";
import Payments from "../../../service/common/PaymentApi";
//service
import IlifestyleService from "../../../service/ilifestyle/ilifestyle";
import UserStore from "../../../store/UserStore";

//data
import ilifepointdata from "./ilifepointdata.json";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import companyName from "../../../store/mobxStore/companyName";
import DropdownButton from "../../components/ilifestylepoint/DropdownButton";
import IlifeModal from "../../components/ilifestylepoint/IlifeModal";
// import DropdownButton from "../../components/ilifestylepoint/Dropdown";
import { CurrencyDecimalFormat } from "../../helper";
import Alert from "../../../assets/images/alert.jpg";

const mapStateToProps = (state) => ({ lang: state.Lang });

const Ewallet = (props) => {
  console.log("🚀 ~ file: iLifestylePoint.jsx:39 ~ Ewal ~ props:", props);
  const Currency = useSelector((state) => state.curr);
  const [click, setClick] = useState(false);
  const { t } = props;
  const [checkout, setCheckout] = useState(false);
  const [card, setCard] = useState("");
  const [extensionAccountDetails, setExtensionAccountDetails] = useState([]);
  const [EwalletAmount, setEwalletAmount] = useState({
    amount: "",
    FormError: {
      amount: "",
    },
    isvalid: false,
  });
  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });

  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const service = new IlifestyleService();
  const [buttonItems, setButtonItems] = useState([]);

  const items = [
    { id: 4, label: "Purchase Items using i- lifestyle points" },
    { id: 1, label: "Petron Card Enrollment" },
    { id: 2, label: "I - Lifestyle Point Conversion" },
    { id: 3, label: "I - Lifestyle Point Consolidation" },
    { id: 5, label: "Samsung Store" },
  ];
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedTab, setselectedTab] = useState("ilifeearning");
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState({
    EarningsTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
    // HistoryTable: {
    //   search: false,
    //   reset: false,
    // },
    StatementTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
  });

  const handleSamsugStore = async () => {
    setClick(true);
    const response = await service.SamsungStore(state.username);
    if (response.status) {
      history.push(
        `/samsung-store/${response.data.username}/${response.data.sessionKey}`
      );
      setClick(false);
    } else {
      setClick(false);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured. Please Try Again Later",
      }));
    }
  };

  const handleItemClick = (item) => {
    console.log(`Clicked item: ${item.label}`);

    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === item.id
    );

    if (itemIndex === -1) {
      if (item.id == 5) {
        const newSelectedItems = [
          ...selectedItems,
          { ...item, displayModal: true, samsungStore: true },
        ];
        setSelectedItems(newSelectedItems);
      } else {
        const newSelectedItems = [
          ...selectedItems,
          { ...item, displayModal: true, samsungStore: false },
        ];
        setSelectedItems(newSelectedItems);
      }
    } else {
      const newSelectedItems = [...selectedItems];
      newSelectedItems[itemIndex].displayModal = true;
      setSelectedItems(newSelectedItems);
    }
  };

  const handleCloseModal = (itemId) => {
    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === itemId
    );
    const newSelectedItems = [...selectedItems];
    newSelectedItems[itemIndex].displayModal = false;
    setSelectedItems(newSelectedItems);
  };

  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();

  const changeHandler = (e) => {
    const { name, value } = e.target;

    setEwalletAmount((prev) => ({
      ...prev,
      [name]: value,
      FormError: {
        ...prev.FormError,
        [name]: "",
      },
      isvalid: false,
    }));
  };

  const [state, setState] = useState({
    username: "",
    Modal: {
      fundTransfer: false,
      addWallet: false,
    },
    tilesData: [],
    balanceAmount: "",
    TransactionFee: "",
    repurchase_status: "yes",
    loading: true,
    DataTables: {
      key: UserStore.checkUserEarnings ? "earning" : "statement",
      statement: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
      },
      history: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
      },
      wallet: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
      },
      earnings: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
        category: [],
      },
    },
    releaseMethod: [],
    pickupAddress: "",
    addressDetails: [],
    deliveryMethod: [],
    itemForEpoint: false,
    petronCardEnrollment: false,
    epointConversion: false,
    epointConsolidation: false,
    samsungStore: false,
    epointsEarned: false,
    epointsTransactionsHistory: false,
  });

  const [clientSecret, setClientSecret] = useState("");

  const [reload, setReload] = useState(false);

  useEffect(() => {
    const newItems = [];
    if (state.itemForEpoint) {
      newItems.push({
        id: 4,
        label: "Purchase Items using i- lifestyle points",
      });
    }
    if (state.petronCardEnrollment) {
      newItems.push({ id: 1, label: "Petron Card Enrollment" });
    }
    if (state.epointConversion) {
      newItems.push({ id: 2, label: "I - Lifestyle Point Conversion" });
    }
    if (state.epointConsolidation) {
      newItems.push({ id: 3, label: "I - Lifestyle Point Consolidation" });
    }
    if (state.samsungStore) {
      newItems.push({ id: 5, label: "Samsung Store" });
    }
    setButtonItems(newItems);
  }, [
    state.itemForEpoint,
    state.petronCardEnrollment,
    state.epointConversion,
    state.epointConsolidation,
    state.samsungStore,
  ]);

  useEffect(() => {
    history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
        if (location.pathname === "/dashboard") {
          UserStore.checkUserEarnings = false;
        }
      }
      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          UserStore.checkUserEarnings = false;
        }
      }
    });
    loadData();
  }, [props, locationKeys, Currency.currentCurr, reload]);

  const checkAvailable = () => {
    let valid = true;
    if (!EwalletAmount.amount) {
      valid = false;
      setEwalletAmount((prev) => ({
        ...prev,
        FormError: {
          ...prev.FormError,
          amount: t("validation.required", { field: "amount" }),
        },
      }));
    }
    if (valid) {
      setCheckout(true);
    }
  };

  //load the data
  const loadData = () => {
    setState((prevState) => ({
      ...prevState,
      tilesData: ilifepointdata.lifeStyleTiles,
      balanceAmount: ilifepointdata.amount,
      TransactionFee: ilifepointdata.transactionFee,
      repurchase_status: ilifepointdata.repurchase_status,
      purchase_wallet: ilifepointdata.purchase_wallet,
      loading: false,
      itemForEpoint: false,
      petronCardEnrollment: false,
      epointConversion: false,
      epointConsolidation: false,
      samsungStore: false,
      epointsEarned: false,
      epointsTransactionsHistory: false,
    }));
    //ewallet tiles
    service.ilifeTile().then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          tilesData: res.data.lifeStyleTiles,
          amount: res.data.amount,
          repurchase_status: res.data.amountWithCurrency,
          loading: false,
          username: res.data.username,
          releaseMethod: res.data.releaseMethod ?? [],
          pickupAddress: res.data.pickupAddress ?? "",
          addressDetails: res.data.addressDetails ?? [],
          deliveryMethod: res.data.deliveryMethod ?? [],
          itemForEpoint: res.data.itemForEpoint ?? false,
          petronCardEnrollment: res.data.petronCardEnrollment ?? false,
          epointConversion: res.data.epointConversion ?? false,
          epointConsolidation: res.data.epointConsolidation ?? false,
          samsungStore: res.data.samsungStore ?? false,
          epointsEarned: res.data.epointsEarned ?? false,
          epointsTransactionsHistory:
            res.data.epointsTransactionsHistory ?? false,
        }));
        setCard(res.data.petronCard);
      } else {
        // props.history.push("/logout");
      }
    });
    service.extensionAccountDetails().then((res) => {
      if (res.status) {
        console.log("extension account details", res);
        setExtensionAccountDetails(res.data);
      }
    });
    getstatementTable();
    getUserEarningsTable();
  };

  //statement table
  const getstatementTable = (
    inPage = state.DataTables.statement.inPage,
    perPage = state.DataTables.statement.perPage,
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY")
  ) => {
    let start = (inPage - 1) * perPage;
    service.statement(start, perPage, startDate, endDate).then((res) => {
      if (res.status) {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          StatementTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
        });
        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            statement: {
              ...prevState.DataTables.statement,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      } else {
        props.history.push("/logout");
      }
    });
  };

  //change statement table
  const changeStatementTable = (inPage, perPage, startDate, endDate) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        statement: {
          ...prevState.DataTables.statement,
          perPage: perPage,
          inPage: inPage,
        },
      },
    }));
    getstatementTable(inPage, perPage, startDate, endDate);
  };

  //change table data
  const changeHistoryTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        history: {
          ...prevState.DataTables.history,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    //getHistoryTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  //wallet table
  const getWalletTable = (
    inPage = state.DataTables.wallet.inPage,
    perPage = state.DataTables.wallet.perPage
  ) => {
    let start = (inPage - 1) * perPage;
    service.wallet(start, perPage).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            wallet: {
              ...prevState.DataTables.wallet,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      } else {
        props.history.push("/logout");
      }
    });
  };

  //change pagination on wallet table
  const changeWalletTable = (inPage, perPage) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        wallet: {
          ...prevState.DataTables.wallet,
          perPage: perPage,
          inPage: inPage,
          // pending     : true
        },
      },
    }));
    getWalletTable(inPage, perPage);
  };

  //get the userearnings table
  const getUserEarningsTable = (
    inPage = state.DataTables.earnings.inPage,
    perPage = state.DataTables.earnings.perPage,
    direction = "",
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY"),
    order = "",
    keys = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service
      .earnigs(start, perPage, direction, startDate, endDate, order, keys)
      .then((res) => {
        if (res.status) {
          setLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            StatementTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
          });

          setState((prevState) => ({
            ...prevState,
            DataTables: {
              ...prevState.DataTables,
              earnings: {
                ...prevState.DataTables.earnings,
                totalRows: res.data.count,
                data: res.data.table_data,
                pending: false,
                category: res.data.category,
              },
            },
          }));
        } else {
          props.history.push("/logout");
        }
      });
  };

  //change table data
  const changeEarningsTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    getUserEarningsTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  //modal close
  const handleClose = () => {
    setCheckout(false);
    setEwalletAmount((prevState) => ({
      ...prevState,
      amount: "",
    }));
    setState((prevState) => ({
      ...prevState,
      Modal: {
        ...prevState.Modal,
        fundTransfer: false,
        addWallet: false,
      },
    }));
  };

  const Translation = (data, tab) => {
    let newData;
    if (tab === "ilifeearning") {
      newData = data.map((item) => {
        console.log("itemsss", item);
        const adjustedTimestamp = moment
          .utc(item.transaction_date)
          .subtract(8, "hours");
        const formattedDate = adjustedTimestamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");
        if (item) {
          return {
            ...item,
            transaction_date: formattedDate,
            points: `${CurrencyDecimalFormat(
              item.points * Currency.value,
              Currency.precision
            )}`,
          };
        } else return item;
      });
    } else {
      newData = data.map((item) => {
        const adjustedTimestamp = moment
          .utc(item.transaction_date)
          .subtract(8, "hours");
        const formattedDate = adjustedTimestamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");
        if (item) {
          return {
            ...item,
            transaction_date: formattedDate,
            total_value: `${(
              parseFloat(item.total_value) * Currency.value
            ).toFixed(Currency.precision)}`,
            total_points: `${(
              parseFloat(item.total_points) * Currency.value
            ).toFixed(Currency.precision)}`,
          };
        } else return item;
      });
    }

    return newData;
  };

  const ExportToExcel = (apiData, fileName, type, tab) => {
    console.log("ExportToExcel", tab);
    let fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let fileExtension = ".xlsx";
    if (tab === "ilifeearning") {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          ["Transaction Date", "Details", "Points"],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          StatementTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          ["Transaction Date", "Details", "Points"],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          StatementTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    } else {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Transaction Date",
            "Ref No",
            "Details",
            "Total Value",
            "Total Points",
          ],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          StatementTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Transaction Date",
            "Ref No",
            "Details",
            "Total Value",
            "Total Points",
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          StatementTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    }
  };

  // Export Data
  const exportData = (
    startdate = "",
    enddate = "",
    categories = "",
    type,
    tab
  ) => {
    console.log("exporttt", tab);
    let keys = categories
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");
    if (tab === "ilifeearning") {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
    } else {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
        });
      }
    }

    if (tab === "ilifeearning") {
      service.earnigsExport(startdate, enddate, keys, type).then((res) => {
        if (type === "excel") {
          ExportToExcel(
            res.data.table_data,
            "Points Earned History Report",
            type,
            tab
          );
        }
        if (type === "csv") {
          ExportToExcel(
            res.data.table_data,
            "Points Earned History Report",
            type,
            tab
          );
        }

        if (type === "print") {
          ExportToExcel(
            res.data.table_data,
            "Points Earned History Report",
            type
          );
        }

        // if(type==='excel'){
        //     fileDownload(res, 'User Earnigs Report.xlsx');
        // }
      });
    } else {
      service.exportData(startdate, enddate, keys, type).then((res) => {
        if (type === "excel") {
          ExportToExcel(res.data.table_data, "Points History Report", type);
        }
        if (type === "csv") {
          ExportToExcel(res.data.table_data, "Points History Report", type);
        }

        if (type === "print") {
          ExportToExcel(res.data.table_data, "Points History Report", type);
        }

        // if(type==='excel'){
        //     fileDownload(res, 'User Earnigs Report.xlsx');
        // }
      });
    }
  };

  //tab change function(ddn't added this)
  const tabChangeHandler = (tab) => {
    setselectedTab(tab);
    console.log("tabbbbb", tab);
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        statement: {
          ...prevState.DataTables.statement,
          perPage: 10,
          inPage: 1,
        },
        history: {
          ...prevState.DataTables.history,
          perPage: 10,
          inPage: 1,
        },
        wallet: {
          ...prevState.DataTables.wallet,
          perPage: 10,
          inPage: 1,
        },
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: 10,
          inPage: 1,
        },
      },
    }));

    getstatementTable();
    // getHistoryTable();
    // getWalletTable();
    getUserEarningsTable();
  };

  const repurchase = () => {
    return state.purchase_wallet === "yes" ? true : false;
  };

  // const ButtonGroup = [
  //   {
  //     name: "purchaseItemUsingILifeStylePoint",
  //     click: fundTransferModal,
  //   },
  //   ...(repurchase()
  //     ? [
  //       {
  //         name: "AddPurchaseWalletFund",
  //         click: purchaseWallet,
  //       },
  //     ]
  //     : []),
  // ];

  const paginationHandler = {
    statement: changeStatementTable,
    history: changeHistoryTable,
    wallet: changeWalletTable,
    earnings: changeEarningsTable,
  };
  return (
    <div className={`h-100`}>
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.ilifestylepoint")}
        </title>
        <script
          src={`https://www.paypal.com/sdk/js?client-id=${clientSecret}&currency=USD`}
        ></script>
      </Helmet>
      <PageTitle
        title="ilifestylepoint"
        //  buttonOn={true} group={ButtonGroup}
      />
      {state.loading ? (
        <Spinner />
      ) : (
        <div className={style.MainContainer}>
          <div>
            {state.tilesData && (
              <Tiles
                tilesData={state.tilesData}
                repurchase_status={state.purchase_wallet}
              />
            )}
          </div>

          {(state.epointsTransactionsHistory || state.epointsEarned) && (
            <Content
              tableData={state.DataTables}
              changeHandler={tabChangeHandler}
              paginationHandler={paginationHandler}
              repurchase_status={state.purchase_wallet}
              exportData={exportData}
              loader={loader}
              selectedTab={selectedTab}
              epointsTransactionsHistory={state.epointsTransactionsHistory}
              epointsEarned={state.epointsEarned}
            />
          )}

          <div className="container">
            <DropdownButton
              buttonText={<>PURCHASE ITEMS USING I - LIFESTYLE POINT</>}
              items={buttonItems}
              onItemClick={handleItemClick}
              // direction='down'
            />
            {selectedItems.map((selectedItem) =>
              selectedItem.displayModal &&
              selectedItem.samsungStore === false ? (
                <div>
                  {console.log("inside modal")}
                  <IlifeModal
                    key={selectedItem.id}
                    item={selectedItem}
                    onClose={() => handleCloseModal(selectedItem.id)}
                    card={card}
                    extensionAccountDetails={extensionAccountDetails}
                    setReload={setReload}
                    reload={reload}
                    state={state}
                  />
                </div>
              ) : selectedItem.displayModal === true &&
                selectedItem.samsungStore === true ? (
                <div>
                  {console.log(" ====== inside pop up ===== ")}
                  <Modal
                    show={true}
                    onHide={() => handleCloseModal(selectedItem.id)}
                    centered
                  >
                    <Modal.Dialog
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Modal.Body
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={Alert}
                          style={{
                            width: "10%",
                            height: "70%",
                            marginTop: "10%",
                          }}
                          alt="Alert Icon"
                        />
                        <strong style={{ marginTop: "10px", fontSize: "25px" }}>
                          Samsung Store
                        </strong>
                        <p style={{ marginTop: "10px", fontSize: "16px" }}>
                          You will leave this site and will be redirected to the
                          Samsung Store. Continue?
                        </p>
                      </Modal.Body>

                      <ModalFooter>
                        <Button
                          variant="secondary"
                          onClick={() => handleCloseModal(selectedItem.id)}
                        >
                          Cancel
                        </Button>

                        <Button
                          variant="secondary"
                          onClick={handleSamsugStore}
                          disabled={click}
                          style={{ backgroundColor: "#9c2718", color: "white" }}
                        >
                          OK
                        </Button>
                      </ModalFooter>
                    </Modal.Dialog>
                  </Modal>
                </div>
              ) : null
            )}
          </div>

          <Modal
            show={state.Modal.fundTransfer}
            onHide={handleClose}
            dialogClassName={`${
              style.ModalDialog
            } animate__animated animate__fadeInRight ${
              state.Modal.fundTransfer
                ? "animate__fadeInRight"
                : "animate__fadeOutRight"
            } FundTransferModal`}
          >
            <Modal.Header closeButton bsPrefix={style.ModalHeader}>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={style.ModalBodyHeader}>
                <h3>{t("ewallet.purchaseItemUsingilifestylPoint")}</h3>
                <div>
                  <br />
                </div>

                <br />
              </div>
              <ModalForms
                balance={state.balanceAmount}
                transFee={state.TransactionFee}
                submitSuccess={loadData}
                handleClose={handleClose}
              />
            </Modal.Body>
          </Modal>
          {/* Add purchse wallet modal */}
          <Modal
            show={state.Modal.addWallet}
            onHide={handleClose}
            dialogClassName={`${
              style.ModalDialog
            } FundTransferModal animate__animated ${
              state.Modal.addWallet
                ? "animate__fadeInRight"
                : "animate__fadeOutRight"
            }  `}
          >
            <Modal.Header closeButton bsPrefix={style.ModalHeader}>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={style.ModalBodyHeader}>
                <h3>{t("ewallet.AddPurchaseWalletFund")}</h3>
              </div>
              <FormInputControl
                label={t("Common.amount")}
                required={true}
                error={{
                  error: EwalletAmount.FormError.amount,
                }}
                // amountAdded = {value => setEwalletAmount(value)}
                checkout={checkout}
                inputProps={{
                  name: "amount",
                  type: "number",
                  placeHolder: t("Common.amount"),
                  onChange: (e) => {
                    changeHandler(e);
                  },
                }}
              />
              {!checkout && (
                <div className="p-2">
                  <pre className={`alert alert-info`}>
                    {t("Common.pwpaypal")}
                  </pre>
                  <div className={style.Buttons}>
                    <Button onClick={checkAvailable} variant="primary">
                      {t("Button.pwpypl")}
                    </Button>
                  </div>
                </div>
              )}
              {checkout && (
                <div className="payment-div">
                  <PaypalPayment
                    amount={EwalletAmount.amount}
                    checkout={(value) => setCheckout(value)}
                    //  getPaypalData={props.getPaypalData}
                  />
                </div>
              )}{" "}
              {/* {  checkin && <div>{paymentPaypal()}</div>} */}
              <ModalForms />
            </Modal.Body>
          </Modal>
        </div>
      )}
      {notify.show && (
        <div>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation()(connect(mapStateToProps)(withRouter(Ewallet)));
